import resourceApi from "@services/resourceApi.jsx";

// 공통 리소스 업로드 필드 컴포넌트
const ResourceUploadField = ({
    label,
    resourceId,
    onResourceUploaded,
    acceptTypes = "*"
}) => {
    const fileInputId = `${label ? label.replace(/\s/g, '') : 'resource'}_file_${Math.random().toString(36).substring(2, 9)}`;

    const handleFileChange = async (e) => {
        if (e.target.files.length > 0) {
            const file = e.target.files[0];

            // 파일 유형 검증
            if (acceptTypes === "image/*" && !file.type.startsWith('image/')) {
                alert('이미지 파일만 업로드 가능합니다.');
                return;
            }

            if (acceptTypes === "audio/*" && !file.type.startsWith('audio/')) {
                alert('오디오 파일만 업로드 가능합니다.');
                return;
            }

            if (acceptTypes === "video/*" && !file.type.startsWith('video/')) {
                alert('동영상 파일만 업로드 가능합니다.');
                return;
            }

            try {
                const resource = await resourceApi.uploadFile(file, '');
                onResourceUploaded(resource.id);
            } catch (error) {
                console.error(`${label || '리소스'} 업로드 실패:`, error);
                alert('파일 업로드에 실패했습니다.');
            }
        }
    };

    return (
        <div className="settings-row">
            {label && <div className="settings-label">{label}</div>}
            <div className="settings-input">
                <input
                    type="text"
                    placeholder="URL"
                    value={resourceId || ""}
                    readOnly={true}
                />
                <input
                    type="file"
                    id={fileInputId}
                    style={{ display: "none" }}
                    accept={acceptTypes}
                    onChange={handleFileChange}
                />
            </div>
            <button
                className="btn upload-btn"
                onClick={() => document.getElementById(fileInputId).click()}
            >
                불러오기
            </button>
        </div>
    );
};

export default ResourceUploadField;